import { CoreAPI, createCommonRouteMethods } from '@hero/sdk-core';

/**
 * Carrier-facing Route APIs. v2 surface is the same shared CRUD across
 * roles — the controller enforces seller / buyer authorization. We keep a
 * thin wrapper here so adding carrier-only Route extensions later (e.g.
 * carrier templates, route imports) doesn't require touching every SDK.
 */
export function createRoutesAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonRouteMethods(coreAPI),
  };
}
